<template>
  <div class="form-group-simple datepicker"
  :class="{
    'form-group-simple--completed': completed,
    'form-group-simple--error': errors.has('date')}">
    <label :for="id" v-if="label">{{ label }}</label>
    <datepicker
      ref="input"
      type="text"
      v-model="date"
      @input="change"
      :name="name"
      :id="id"
      placeholder="dd-mm-jjjj"
      @blur="blur"
      @focusin.native="opened"
      format="dd-MM-yyyy"
      :disabledDates="disabledDates"
      :disabled = "disabled"
      :customKey="customKey"
      :language="nl"
      :highlighted="highlighted"
      >
    </datepicker>
    <div class="form-group-simple__details">
      <div class="form-group-simple__messages">
        <div class="form-group-simple__error" v-show="errors.has('date')">{{ errors.first('date') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import moment from 'moment'
import { Validator } from 'vee-validate'
import Datepicker from 'vuejs-datepicker'
import { nl } from 'vuejs-datepicker/dist/locale'

export default {
  name: 'v-input-date-picker',
  components: {
    Datepicker
  },
  props: {
    autofocus: {
      default: false,
      type: Boolean
    },
    name: {
      default: 'name',
      type: String
    },
    id: {
      default: 'id',
      type: String
    },
    label: {
      default: '',
      type: String
    },
    customKey: {
      default: 0,
      type: Number
    },
    value: {
      default: '',
      type: String
    },
    customDateRange: {
      default: false,
      type: Boolean
    },
    customDOB: {
      default: false,
      type: Boolean
    },
    osaTherapyStartDate: {
      default: false,
      type: Boolean
    },
    accountabiliyStartDate: {
      default: false,
      type: Boolean
    },
    customStartDate: {
      default: null,
      type: String
    },
    accountabiliyQuestionDate: {
      default: false,
      type: Boolean
    },
    osaDate: {
      default: false,
      type: Boolean
    },
    emptyDate: {
      default: false,
      type: Boolean
    },
    disableFutureDates: {
      default: false,
      type: Boolean
    },
    dateBetweenRange: {
      default: null,
      type: Number
    },
    disableNextDate: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    },
    holidayDates: {
      default: null,
      type: Array
    }
  },
  data () {
    return {
      date: ( this.emptyDate || this.customDOB ) ? '' : this.value !== '' ? new Date(this.value) : new Date(),
      errors: '',
      completed: false,
      nl: nl,
      highlighted: {
        dates: [new Date()]
      }
    }
  },
  watch: {
    value (val) {
      if (!val) {
        this.date = ''
      }
    }
  },
  computed: {
    disabledDates () {
      let disabledDates = {
      }
      let yesterday = new Date()
      disabledDates.to = new Date(yesterday.setDate(yesterday.getDate() - 1))
      if (this.customDateRange) {
        let customDateRangeDateFrom = new Date()
        disabledDates.from = new Date(customDateRangeDateFrom.setDate(customDateRangeDateFrom.getDate() + 7))
        if (store.state.navigation.siteCode === 'MIF') {
          let customDateRangeDateTo = new Date()
          disabledDates.to = new Date(customDateRangeDateTo.setDate(customDateRangeDateTo.getDate() - 8))
        }
        if (this.accountabiliyStartDate) {
          let customDateRangeDateFrom = new Date()
          disabledDates.from = new Date(customDateRangeDateFrom.setDate(customDateRangeDateFrom.getDate() + 14))
          if (store.state.navigation.siteCode === 'MIF') {
            let customDateRangeDateTo = new Date()
            disabledDates.to = new Date(customDateRangeDateTo.setDate(customDateRangeDateTo.getDate() - 15))
          }
        }
      } else if (this.customDOB) {
        // disable all date before 'to' date
        disabledDates.to = moment().subtract(100, 'years').toDate()
        // disable all date after 'from' date
        disabledDates.from = new Date()
      }
      if (this.accountabiliyQuestionDate) {
        let customDateRangeDateTo = new Date()
        disabledDates.to = new Date(customDateRangeDateTo.setDate(customDateRangeDateTo.getDate() - 15))
      }
      if (store.state.navigation.siteCode === 'MRT') {
        let customDateRangeDateTo = new Date()
        let customDateRangeDateFrom = new Date()
        disabledDates.to = new Date(customDateRangeDateTo.setYear(customDateRangeDateTo.getFullYear() - 5))
        disabledDates.from = new Date(customDateRangeDateFrom.setMonth(customDateRangeDateFrom.getMonth() + 3))
      }
      if (this.customStartDate !== null) {
        disabledDates.to = new Date(this.customStartDate)
      }
      if (this.osaDate) {
        let customDateRangeDateFrom = new Date()
        // disable all date before 'to' date
        disabledDates.to = moment().subtract(100, 'years').toDate()
        // disable all date after 'from' date
        disabledDates.from = new Date(customDateRangeDateFrom.setDate(customDateRangeDateFrom.getDate() + 3))
      }
      if (this.osaTherapyStartDate) {
        // disable all date before 'to' date
        disabledDates.to = moment().subtract(70, 'years').toDate()
        // disable all date after 'from' date
        disabledDates.from = moment().add(70, 'years').toDate()
      }
      if (this.disableFutureDates) {
        disabledDates.from = new Date()
      } else {
        disabledDates = {}
      }
      if(this.holidayDates)
      {
        let holidaysFormattedDates = [];
        this.holidayDates.forEach(element => {
          holidaysFormattedDates.push(new Date(moment(element, 'DD-MM-YYYY')))
        });
        disabledDates.dates = holidaysFormattedDates
      }
      if (this.dateBetweenRange) {
        disabledDates.from = new Date()
        disabledDates.from.setMonth(disabledDates.from.getMonth() + 2)
        disabledDates.from.setDate(disabledDates.from.getDate() - 1)
        disabledDates.to = new Date()
      }
      if (this.disableNextDate) {
        disabledDates.to.setDate(disabledDates.to.getDate() + 1)
      }
      return disabledDates
    }
  },
  created () {
    this.validator = new Validator()
    this.validator.attach(
      'date',
      'required',
      { alias: 'Datum' })
    this.$set(this, 'errors', this.validator.errors)
    if (!this.emptyDate) {
      this.change()
    } 
  },
  methods: {
    bottomVisible () {
      const scrollY = window.scrollY || document.documentElement.scrollTop
      const visible = document.documentElement.clientHeight
      const pageHeight = document.documentElement.scrollHeight
      const bottomOfPage = Math.ceil(visible + scrollY) >= Math.ceil(pageHeight)
      return bottomOfPage
    },    
    opened (e) {
      e.preventDefault();
      if(this.bottomVisible()) {
        document.querySelectorAll(".vdp-datepicker__calendar").forEach(el => {
            el.classList.add("positionClass");
        });
          setTimeout(() => {
            window.scrollBy({top: 324, behavior: "smooth"})
        }, 500);
      } else {
        document.querySelectorAll(".vdp-datepicker__calendar").forEach(el => {
            el.classList.remove("positionClass");
        });        
      }
    },
    change () {
      // Replace letters from the date value
      let temp = moment(this.date).format('DD-MM-YYYY')
      // End of input, validate it to see if it is complete

      if (temp.length > 9) {
        // Validate date
        this.validator.validate('date', temp)
        // If input has no errors
        if (!this.errors.has('date')) {
          this.completed = true
        } else {
          this.completed = false
        }
        this.$emit('updateValidation', temp)
        this.$emit('selected', temp, this.id, this.customKey)
      }
    },
    validate () {
      this.validator.validate('date', this.date)
    },
    blur (e) {
      if (e.currentTarget.value.length > 0) {
        this.validate()
      }
    }
  }
}
</script>
<style lang="scss">
.datepicker {
  .positionClass {
    position: relative !important;
  }
  input {
    padding-left: 30px;
    background: url(/icons/calendar-range.svg) no-repeat scroll 2px 12px, $white;
    cursor: pointer;
    border: 1px solid $gray;
    width: 100%;
    width: -moz-available;          /* WebKit-based browsers will ignore this. */
    width: -webkit-fill-available;  /* Mozilla-based browsers will ignore this. */
  }
}
</style>
